<template>
  <DefaultPage>
    <section class="section" id="striving">
        <div class="grid-container">
            <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
                <div class="panel__item grid-x grid-margin-x align-center">
                    <div class="panel__item__headline cell medium-6">
                        <h1 class="panel__item__headline__title">
                            Continually Striving to <br>Exceed Your <span class="blue-color">Needs</span>
                        </h1>
                    </div>
                    <div class="panel__item__content cell medium-6"
                    data-aos="fade-up">
                        <div class="panel__item__content__text">
                            <p>As one of the largest and most successful insurance ventures of its kind, with an incredibly strong financial position, SVMIC employs over 140 professionals experienced in finance, law, claims, risk management, insurance, accounting, underwriting, nursing, marketing, information technology, and practice management who are dedicated to a single objective — serving physicians and their practices.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- animated shapes -->
        <div class="triangle-ready-top-wrap">
          <div class="shape triangle triangle--ready-top"></div>
        </div>
        <div class="shape shape--has-bg dot dot--ready-top"></div>
        <div class="shape circle circle--ready-top"></div>
        <div class="shape circle circle--ready-top-blur"></div>
        <div class="shape circle circle--ready-top-blue"></div>
    </section>
    <section class="section" id="providing">
        <div class="grid-container">
            <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
                <div class="panel__item grid-x grid-margin-x align-center">
                    <div class="panel__item__content cell medium-6"
                    data-aos="fade-up">
                        <div class="panel__item__content__text">
                            <p>When a problem occurs, you need a proactive partner that can navigate unforeseen challenges and help you solve the tough legal issues that come with practicing medicine.</p>
                        </div>
                    </div>
                    <div class="panel__item__headline cell medium-6">
                        <h1 class="panel__item__headline__title panel__item__headline__title--gray">
                            Providing for Every <br>Single One of Our <br> <span class="orange-color">Policyholders</span>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
        <!-- shapes -->
        <div class="triangle-ready-mid-wrap">
          <div class="shape shape--has-bg triangle triangle--ready-mid"></div>
        </div>
        <div class="shape dot dot--ready-mid"></div>
        <div class="shape circle circle--ready-mid-big"></div>
        <div class="shape circle circle--ready-mid-small"></div>
        <div class="shape circle circle--ready-mid-blur"></div>
        <div class="shape squares squares--ready-mid">
          <div class="square"></div>
          <div class="square"></div>
        </div>
    </section>
    <section class="section" id="educating">
        <div class="grid-container">
            <div class="panel" data-aos="fade"
                           data-aos-duration="1000">
                <div class="panel__item grid-x grid-margin-x align-center">
                    <div class="panel__item__headline cell medium-6">
                        <h1 class="panel__item__headline__title">
                            Educating and <br>Informing Through <br> Our Many <span class="gold-color">Resources</span>
                        </h1>
                    </div>
                    <div class="panel__item__content cell medium-6"
                    data-aos="fade-up">
                        <div class="panel__item__content__text panel__item__content__text--white">
                            <p>Our teams of experts work hard to provide our members with the most robust set of resources out there to help them protect their practices from risk. We collaborate with our members, our internal teams, and leading industry experts to produce relevant and insightful content to make us all better physicians.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- shapes -->
        <div class="triangle-ready-bottom-wrap-solid">
          <div class="shape shape--has-bg triangle triangle--ready-bottom-one"></div>
        </div>
        <div class="triangle-ready-bottom-wrap-blur">
          <div class="shape shape--has-bg triangle triangle--ready-bottom-two"></div>
        </div>
        <div class="shape circle circle--ready-bottom-big"></div>
        <div class="shape circle circle--ready-bottom-blur"></div>
        <div class="shape squares squares--ready-bottom">
          <div class="square"></div>
          <div class="square"></div>
        </div>
    </section>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';

export default {
  name: 'Focus',
  components: { DefaultPage },
  mounted () {
    $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
      if ($(window).width() > 1024) {
        $('.panel__item__icon .person').css({
          transform: 'translateY(-' + scrollPos / 30 + 'px)'
        });
        $('.panel__item__icon .setting').css({
          transform: 'translateX(' + scrollPos / 40 + 'px)'
        });
        $('.panel__item__icon--tools .setting').css({
          transform: 'translateX(-' + scrollPos / 40 + 'px)'
        });
      }
    });
    $(window).resize(function () {
      if ($(window).width() < 1024) {
        $('.panel__item__icon .person').css({
          transform: 'translateY(0)'
        });
        $('.panel__item__icon .setting').css({
          transform: 'translateX(0)'
        });
        $('.panel__item__icon--tools .setting').css({
          transform: 'translateX(0)'
        });
      }
    });
  }
};
</script>
